/* eslint-disable no-case-declarations */
import {
  FETCH_ALGO_BY_ID_FAILURE,
  FETCH_ALGO_BY_ID_REQUEST,
  FETCH_ALGO_BY_ID_SUCCESS,
  ALGO_EDIT_CONFIG_SETTINGS_TOGGLE_CLIENT_ID_SHOW,
  ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_CANCEL,
  ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_ON,
  ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_SAVE,
  ALGO_STATUS_UPDATE,
  HEALTH_STATUS,
  ALGO_EDIT_CONFIG_SETTINGS_TERMINATE_START,
  ALGO_EDIT_CONFIG_SETTINGS_TERMINATE_STOP,
  ALGO_EDIT_CONFIG_SETTINGS_SQ_OFF_START,
  ALGO_EDIT_CONFIG_SETTINGS_SQ_OFF_STOP,
  ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_SAVE_START,
  ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_SAVE_STOP,
  ALGO_EDIT_UPDATE_CREATE_LEG_DATA,
  ALGO_EDIT_UPDATE_CONFIG_DATA,
  ALGO_EDIT_CREATE_LEG,
  ALGO_EDIT_UPDATE_CONFIG_LEG_DATA,
  ALGO_EDIT_OPEN_POSITION_TABLE_MODAL,
  ALGO_EDIT_CLOSE_POSITION_TABLE_MODAL,
  ALGO_EDIT_DELETE_CONFIG_LEG,
  ALGO_EDIT_DUPLICATE_CONFIG_LEG,
  ALGO_EDIT_PAGE_LOADED_TRUE,
  ALGO_EDIT_PAGE_LOADED_FALSE,
  ALGO_EDIT_UPDATE_PROFIT_LOCK_TRAILING_SL,
  ALGO_EDIT_SAVE_START,
  ALGO_EDIT_SAVE_STOP,
  ALGO_EDIT_VALIDATION_FAILURE,
  ALGO_EDIT_VALIDATION_CLEAR,
  ALGO_EDIT_PRE_SAVE_CONFIG_FIX,
  ALGO_EDIT_CONFIGURATION_DECORATOR,
  ALGO_EDIT_CHANGE_NAME,
  ALGO_EDIT_CONFIG_SAVE_EABLED,
  ALGO_EDIT_CONFIG_SAVE_DISABLED,
  ALGO_EDIT_CONFIG_CREATE_MODAL_OPEN,
  ALGO_EDIT_CONFIG_CREATE_MODAL_CLOSE,
  ALGO_EDIT_CONFIG_RESET,
  ALGO_EDIT_CONFIRMATIONS_POSITIONAL_MIS_DONE,
  ALGO_EDIT_CONFIRMATIONS_POSITIONAL_MIS,
  ALGO_EDIT_DUPLICAT_CONFIG_LEG_LOADING,
  ALGO_EDIT_JOURNEY_SELECT_UPDATE,
  ALGO_EDIT_CREATE_ALGO_REQUEST,
  ALGO_EDIT_CREATE_ALGO_ERROR,
  ALGO_EDIT_LEG_MULTI_SELECT,
  ALGO_EDIT_BULK_EDIT_LEG_PREMIUM_INPUT_INCREMENT,
} from '../../constants/ActionTypes';
import { ALGO_EDIT_CLIENT_ID_SHOW } from '../../constants/cookies';
import storage from '../../storage';
import { createLegDefault } from './defaultValues';
import {
  updateAlgoStatus,
  updateSettingsClientIdToggle,
  updateSettingsModifyWhileLive,
  updateSettingsTerminate,
  updateSettingsSqOff,
  updateSettingsSave,
  updatecreateLegUpdateData,
  updatecreateValidateCreateLeg,
  updateCreateLeg,
  updateConfigLegUpdateData,
  updatePositionModaldata,
  updateConfigurationUpdateData,
  updateConfigurationDeleteLegUpdateData,
  updateConfigurationDuplicateLegUpdateData,
  updateProfitLockTrailingSl,
  updateSettingsLoading,
  updatePreSaveConfigFix,
  updateConfigurationDecorator,
  updateNameChange,
  updateConfigSave,
  updateCreateModalOpen,
  updateConfigLegMultiSelect,
  updateConfigLegPremiumInputIncrement,
} from './updaters';
import { uniqueId } from '../../helpers/unique-id';
import { setLegsPremiumWidth } from '../../helpers/legs-premium';
import { updateConfigLegJourneySelectUpdateData } from './journey-updators';
import {
  futuresSelectOptions,
  optionsSelectOptions,
} from '../../partials/AlgoConfig/PositionsTable/LegInstrumentToggle/Contracts';

const premiumLegsWidthSelective = (data, action) => {
  const actionField = [
    'premium',
    'strike',
    'atmPercent',
    'straddleWidth',
    'straddlePremium',
    'underlyingPC',
    'sp',
    'selectionType',
  ];

  if (actionField.includes(action?.field)) {
    setLegsPremiumWidth(data);
  }
};

const algoEditConfig = (
  state = {
    data: {},
    dataBackup: {},
    configLegUpdatedAt: null,
    isFetching: false,
    errorMessage: null,
    errors: {},
    createAlgoErrors: {},
    pageLoaded: false,
    loading: false,
    profitLockAndSlTrailing: 'none',
    settings: {
      clientIdShow: storage.getItem(ALGO_EDIT_CLIENT_ID_SHOW)
        ? storage.getItem(ALGO_EDIT_CLIENT_ID_SHOW)
        : false,
      modifyWhileLive: false,
      saveStart: false,
      terminateStart: false,
      sqOffStart: false,
      loading: false,
      configSave: false,
      openCreateModal: false,
    },
    health: {},
    createLeg: createLegDefault,
    createLegErrors: {},
    legDuplicateLoading: false,
    positionTableModals: {
      premiumModal: {
        open: false,
        data: {},
      },
      legsModal: {
        open: false,
        data: {},
      },
      atmPercentModal: {
        open: false,
        data: {},
      },
      underlyingPCModal: {
        open: false,
        data: {},
      },
      straddleWidthModal: {
        open: false,
        data: {},
      },
      straddlePremiumModal: {
        open: false,
        data: {},
      },
      trailingStoplossModal: {
        open: false,
        data: {},
      },
      reEntryModal: {
        open: false,
        data: {},
      },
      reEntryTargetModal: {
        open: false,
        data: {},
      },
      stoplossModal: {
        open: false,
        data: {},
      },
      targetModal: {
        open: false,
        data: {},
      },
      jLegTargetModificationModal: {
        open: false,
        data: {},
      },
      journeyDisabledReEntryModal: {
        open: false,
        data: {},
      },
      reEntryDisabledJourneyModal: {
        open: false,
        data: {},
      },
      specificStrikeModal: {
        open: false,
        data: {},
      },
    },
    confirmations: {
      positionalMIS: {
        done: false,
        open: false,
      },
    },
  },
  action
) => {
  switch (action.type) {
    case FETCH_ALGO_BY_ID_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_ALGO_BY_ID_SUCCESS:
      setLegsPremiumWidth(action.data.data);

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_ALGO_BY_ID_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    case ALGO_STATUS_UPDATE:
      // skip if page other than algos
      const urlStatusUpdate = window.location.href;
      const algoIdStatusUpdate = urlStatusUpdate.substring(
        urlStatusUpdate.lastIndexOf('/') + 1
      );

      if (
        !action.data ||
        !action.data.algo ||
        algoIdStatusUpdate !== action.data.algo ||
        !action.data.status ||
        !state.data ||
        !state.data.data
      ) {
        return state;
      }

      const { data: dataStatusUpdate } = updateAlgoStatus(state, action);

      return {
        ...state,
        data: dataStatusUpdate,
      };
    case HEALTH_STATUS:
      return {
        ...state,
        health: action.data,
      };
    case ALGO_EDIT_CONFIG_SETTINGS_TOGGLE_CLIENT_ID_SHOW:
      const settingsClientIdToggle = updateSettingsClientIdToggle(state);

      storage.setItems({
        [ALGO_EDIT_CLIENT_ID_SHOW]: settingsClientIdToggle.clientIdShow,
      });

      return {
        ...state,
        settings: settingsClientIdToggle,
      };
    case ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_ON:
      const settingsModifyWhileLiveOn = updateSettingsModifyWhileLive(
        state,
        true
      );

      return {
        ...state,
        settings: settingsModifyWhileLiveOn,
        dataBackup: JSON.parse(JSON.stringify(state.data)),
      };
    case ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_CANCEL:
      const settingsModifyWhileLiveOff = updateSettingsModifyWhileLive(
        state,
        false
      );

      return {
        ...state,
        settings: settingsModifyWhileLiveOff,
        data: JSON.parse(JSON.stringify(state.dataBackup)),
        errors: {},
      };
    case ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_SAVE_START:
      const settingsModifyWhileLiveSaveStart = updateSettingsSave(state, true);

      return {
        ...state,
        settings: settingsModifyWhileLiveSaveStart,
      };
    case ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_SAVE_STOP:
      const settingsModifyWhileLiveSaveStop = updateSettingsSave(state, false);

      return {
        ...state,
        settings: settingsModifyWhileLiveSaveStop,
      };
    case ALGO_EDIT_CONFIG_MODIFY_WHILE_LIVE_SAVE:
      const settingsModifyWhileLiveSave = updateSettingsModifyWhileLive(
        state,
        false
      );

      return {
        ...state,
        settings: settingsModifyWhileLiveSave,
        dataBackup: {},
      };
    case ALGO_EDIT_CONFIG_SETTINGS_TERMINATE_START:
      const settingsTerminateStart = updateSettingsTerminate(state, true);

      return {
        ...state,
        settings: settingsTerminateStart,
      };
    case ALGO_EDIT_CONFIG_SETTINGS_TERMINATE_STOP:
      const settingsTerminateStop = updateSettingsTerminate(state, false);

      return {
        ...state,
        settings: settingsTerminateStop,
      };
    case ALGO_EDIT_CONFIG_SETTINGS_SQ_OFF_START:
      const settingsSqOffStart = updateSettingsSqOff(state, true);

      return {
        ...state,
        settings: settingsSqOffStart,
      };
    case ALGO_EDIT_CONFIG_SETTINGS_SQ_OFF_STOP:
      const settingsSqOffStop = updateSettingsSqOff(state, false);

      return {
        ...state,
        settings: settingsSqOffStop,
      };
    case ALGO_EDIT_UPDATE_CREATE_LEG_DATA:
      const createLegUpdateData = updatecreateLegUpdateData(state, action);

      return {
        ...state,
        createLeg: createLegUpdateData,
      };
    case ALGO_EDIT_CREATE_LEG:
      const createLegErrorValidate = updatecreateValidateCreateLeg(state);
      const dayUnderlyingsExpiryTags = action.dayUnderlyingsExpiryTags;

      const finalContract = state.createLeg.side
        ? optionsSelectOptions
        : futuresSelectOptions;

      const valuesFinalContract = finalContract.map((item) => item.value);

      const baseExpiryTags =
        dayUnderlyingsExpiryTags[state.createLeg.base] || [];

      const filtredFinalContract = valuesFinalContract.filter((item) =>
        baseExpiryTags.includes(item)
      );

      const selectedExpiryTag = filtredFinalContract?.length
        ? filtredFinalContract[0]
        : '';

      const isError = Object.keys(createLegErrorValidate).length ? true : false;

      if (isError) {
        return {
          ...state,
          createLegErrors: createLegErrorValidate,
        };
      }

      const leg = {
        id: `${uniqueId()}`,
        ...state.createLeg,
        mp: false,
        product: 'I',
        expiryTag: selectedExpiryTag,
      };

      const { data: dataUpdateCreateLeg } = updateCreateLeg(state, leg);

      setLegsPremiumWidth(dataUpdateCreateLeg);

      return {
        ...state,
        data: dataUpdateCreateLeg,
        errors: {},
      };
    case ALGO_EDIT_UPDATE_CONFIG_LEG_DATA:
      const { data: dataConfigLegUpdateData } = updateConfigLegUpdateData(
        state,
        action
      );

      premiumLegsWidthSelective(dataConfigLegUpdateData, action);

      return {
        ...state,
        data: dataConfigLegUpdateData,
        configLegUpdatedAt: Date.now(),
      };
    case ALGO_EDIT_JOURNEY_SELECT_UPDATE:
      const { data: dataEditJourneySelectUpdate } =
        updateConfigLegJourneySelectUpdateData(state, action);

      return {
        ...state,
        data: dataEditJourneySelectUpdate,
      };
    case ALGO_EDIT_UPDATE_CONFIG_DATA:
      const { data: dataConfigUpdateData } = updateConfigurationUpdateData(
        state,
        action
      );

      return {
        ...state,
        data: dataConfigUpdateData,
      };
    case ALGO_EDIT_DELETE_CONFIG_LEG:
      const { data: dataDeleteConfigLeg } =
        updateConfigurationDeleteLegUpdateData(state, action);

      setLegsPremiumWidth(dataDeleteConfigLeg);

      return {
        ...state,
        data: dataDeleteConfigLeg,
        errors: {},
      };
    case ALGO_EDIT_DUPLICATE_CONFIG_LEG:
      const { data: dataDuplicateConfigLeg } =
        updateConfigurationDuplicateLegUpdateData(state, action);

      return {
        ...state,
        data: dataDuplicateConfigLeg,
        legDuplicateLoading: true,
        errors: {},
      };
    case ALGO_EDIT_DUPLICAT_CONFIG_LEG_LOADING:
      return {
        ...state,
        legDuplicateLoading: action.data,
      };
    case ALGO_EDIT_OPEN_POSITION_TABLE_MODAL:
      const positionTableModalsOpen = updatePositionModaldata(
        state,
        action,
        true
      );

      return {
        ...state,
        positionTableModals: positionTableModalsOpen,
      };
    case ALGO_EDIT_CLOSE_POSITION_TABLE_MODAL:
      const positionTableModalsClose = updatePositionModaldata(
        state,
        action,
        false
      );

      return {
        ...state,
        positionTableModals: positionTableModalsClose,
      };
    case ALGO_EDIT_PAGE_LOADED_TRUE:
      return {
        ...state,
        pageLoaded: true,
      };
    case ALGO_EDIT_PAGE_LOADED_FALSE:
      return {
        ...state,
        pageLoaded: false,
      };
    case ALGO_EDIT_UPDATE_PROFIT_LOCK_TRAILING_SL:
      const { data: dataEditUpdateProfitLockTrailingSl } =
        updateProfitLockTrailingSl(state, action);

      return {
        ...state,
        profitLockAndSlTrailing: action.value,
        data: dataEditUpdateProfitLockTrailingSl,
      };
    case ALGO_EDIT_SAVE_START:
      const settingsAlgoSaveStart = updateSettingsLoading(state, true);

      return {
        ...state,
        settings: settingsAlgoSaveStart,
      };
    case ALGO_EDIT_SAVE_STOP:
      const settingsAlgoSaveStop = updateSettingsLoading(state, false);

      return {
        ...state,
        settings: settingsAlgoSaveStop,
      };
    case ALGO_EDIT_VALIDATION_FAILURE:
      return {
        ...state,
        errors: action.errors,
      };
    case ALGO_EDIT_VALIDATION_CLEAR:
      return {
        ...state,
        errors: {},
      };
    case ALGO_EDIT_PRE_SAVE_CONFIG_FIX:
      const { data: dataPreSaveConfigFix } = updatePreSaveConfigFix(
        state,
        action
      );

      return {
        ...state,
        data: dataPreSaveConfigFix,
      };
    case ALGO_EDIT_CONFIGURATION_DECORATOR:
      const { data: dataConfigurationDecorator } = updateConfigurationDecorator(
        state,
        action
      );

      return {
        ...state,
        data: dataConfigurationDecorator,
      };
    case ALGO_EDIT_CHANGE_NAME:
      const { data: dataNameChange } = updateNameChange(state, action);

      return {
        ...state,
        data: dataNameChange,
      };
    case ALGO_EDIT_CONFIG_SAVE_EABLED:
      const settingsConfigSaveEnable = updateConfigSave(state, true);

      return {
        ...state,
        settings: settingsConfigSaveEnable,
      };
    case ALGO_EDIT_CONFIG_SAVE_DISABLED:
      const settingsConfigSaveDisable = updateConfigSave(state, false);

      return {
        ...state,
        settings: settingsConfigSaveDisable,
      };
    case ALGO_EDIT_CONFIG_CREATE_MODAL_OPEN:
      const settingsConfigCreateModalOpen = updateCreateModalOpen(state, true);

      return {
        ...state,
        settings: settingsConfigCreateModalOpen,
      };
    case ALGO_EDIT_CONFIG_CREATE_MODAL_CLOSE:
      const settingsConfigCreateModalClose = updateCreateModalOpen(
        state,
        false
      );

      return {
        ...state,
        settings: settingsConfigCreateModalClose,
      };
    case ALGO_EDIT_CONFIRMATIONS_POSITIONAL_MIS:
      return {
        ...state,
        confirmations: {
          ...state.confirmations,
          positionalMIS: {
            done: false,
            open: action.data,
          },
        },
      };
    case ALGO_EDIT_CONFIRMATIONS_POSITIONAL_MIS_DONE:
      return {
        ...state,
        confirmations: {
          ...state.confirmations,
          positionalMIS: {
            done: true,
            open: false,
          },
        },
      };
    case ALGO_EDIT_CREATE_ALGO_REQUEST:
      return {
        ...state,
        createAlgoErrors: {},
      };
    case ALGO_EDIT_CREATE_ALGO_ERROR:
      return {
        ...state,
        createAlgoErrors: action.errors,
      };
    case ALGO_EDIT_LEG_MULTI_SELECT:
      const { data: dataConfigLegMultiSelect } = updateConfigLegMultiSelect(
        state,
        action
      );

      return {
        ...state,
        data: dataConfigLegMultiSelect,
      };
    case ALGO_EDIT_BULK_EDIT_LEG_PREMIUM_INPUT_INCREMENT:
      const { data: dataLegPremiumInputIncrement } =
        updateConfigLegPremiumInputIncrement(state, action);

      return {
        ...state,
        data: dataLegPremiumInputIncrement,
      };
    case ALGO_EDIT_CONFIG_RESET:
      return {
        data: {},
        dataBackup: {},
        createAlgoErrors: {},
        isFetching: false,
        errorMessage: null,
        errors: {},
        pageLoaded: false,
        loading: false,
        profitLockAndSlTrailing: 'none',
        settings: {
          clientIdShow: storage.getItem(ALGO_EDIT_CLIENT_ID_SHOW)
            ? storage.getItem(ALGO_EDIT_CLIENT_ID_SHOW)
            : false,
          modifyWhileLive: false,
          saveStart: false,
          terminateStart: false,
          sqOffStart: false,
          loading: false,
          configSave: false,
          openCreateModal: false,
        },
        health: {},
        createLeg: createLegDefault,
        createLegErrors: {},
        legDuplicateLoading: false,
        positionTableModals: {
          premiumModal: {
            open: false,
            data: {},
          },
          legsModal: {
            open: false,
            data: {},
          },
          atmPercentModal: {
            open: false,
            data: {},
          },
          underlyingPCModal: {
            open: false,
            data: {},
          },
          straddleWidthModal: {
            open: false,
            data: {},
          },
          straddlePremiumModal: {
            open: false,
            data: {},
          },
          trailingStoplossModal: {
            open: false,
            data: {},
          },
          reEntryModal: {
            open: false,
            data: {},
          },
          reEntryTargetModal: {
            open: false,
            data: {},
          },
          stoplossModal: {
            open: false,
            data: {},
          },
          targetModal: {
            open: false,
            data: {},
          },
          jLegTargetModificationModal: {
            open: false,
            data: {},
          },
          journeyDisabledReEntryModal: {
            open: false,
            data: {},
          },
          reEntryDisabledJourneyModal: {
            open: false,
            data: {},
          },
          specificStrikeModal: {
            open: false,
            data: {},
          },
        },
        positionTableJourneyModals: {
          premiumModal: {
            open: false,
            data: {},
          },
          legsModal: {
            open: false,
            data: {},
          },
          atmPercentModal: {
            open: false,
            data: {},
          },
          straddleWidthModal: {
            open: false,
            data: {},
          },
          straddlePremiumModal: {
            open: false,
            data: {},
          },
          trailingStoplossModal: {
            open: false,
            data: {},
          },
          reEntryModal: {
            open: false,
            data: {},
          },
          reEntryTargetModal: {
            open: false,
            data: {},
          },
          stoplossModal: {
            open: false,
            data: {},
          },
          targetModal: {
            open: false,
            data: {},
          },
        },
        confirmations: {
          positionalMIS: {
            done: false,
            open: false,
          },
        },
      };
    default:
      return state;
  }
};

export default algoEditConfig;
